import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WallboardsService } from '../../wallboards.service';
import { WVData, WVMain } from '../wallboard-view.model';
import { ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-video',
    templateUrl: './wallboard-view-video.component.html',
    styleUrls: ['./wallboard-view-video.component.scss']
})
export class WallboardViewVideoComponent implements OnInit, OnDestroy {
    @Input() firstSlide;

    public wvf: WVMain;
    public wvvf: WVData;
    public videoState;

    public player;
    public playerID: string;

    private isDestroyed: boolean = false;
    private isPlayerReady: boolean = false;

    get moduleKey(): string {
        return this.wvvf?.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "";
    }

    constructor(
        private service: WallboardViewService,
        public wallboardsService: WallboardsService,
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvvf = this.service.WVVideo;

        this.wvf.RunSlide = this.firstSlide;
        this.playerID = this.moduleKey + Date.now();

        this.wallboardsService.loadTypeState(ModuleType.Video, this.moduleKey, this.wvf.WallboardCreatorID).then(response => {
            if (this.isDestroyed)
                return;

            this.videoState = response.Video_Settings;

            const results = this.videoState.VideoURL.match('[\\?&]v=([^&#]*)');

            // YT is the youtube api object the first parameter is the ID of the element to be overtaken by the player. The secn parameter is the list of options
            this.player = new (window as any).YT.Player(this.playerID, {
                height: '100%',
                width: '100%',
                videoId: results[1],
                events: {
                    'onReady': () => this.onPlayerReady(),
                    'onError': () => this.onPlayerError(),
                    'onStateChange': (event) => this.onPlayerStateChange(event)
                },
                playerVars: {
                    modestbranding: 1,      //minimizes the amount of youtube brand flair in the player
                    playsinline: 0,         //sets the playback to be in fullscreen mode (required for iOS)
                    rel: 0,                 //stops related videos from being shown when the video ends
                    fs: 0,                  //Removes the fullscreen button from the bottom of the player
                    showinfo: 0,            //Prevents the player from showing video info such as the name and uploader at the start of the video
                    controls: 0,            //removes the controls from the player
                    host: 'https://' + this.videoState.OriginDomain,      //this is set as a security feature otherwise a warning about xss will frequently appear in the console
                }
            });

            if (!this.isPlayerReady) {
                if (!this.firstSlide) {
                    this.wvf.NextSlideReady = true;
                }
                else {
                    this.wvf.FirstSlideReady = true;
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    public onPlayerError() {
        if (!this.firstSlide) {
            this.wvf.NextSlideReady = true;
        }
        else {
            this.wvf.FirstSlideReady = true;
        }
    }

    public onPlayerStateChange(event) {
        if (event == 0) {
            if (!this.firstSlide) {
                this.wvf.NextSlideReady = true;
            }
            else {
                this.wvf.FirstSlideReady = true;
            }
        }
    }

    public onPlayerReady() {
        this.isPlayerReady = true;
        if (!this.firstSlide) {
            this.wvf.NextSlideReady = true;
            this.wvf.Slides[this.wvf.NextSlide].SlideInterval = this.player.getDuration() + 1; // When the video is loaded, ensures that the interval is set to allow the full video to play
        }
        else {
            this.wvf.FirstSlideReady = true;
            this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval = this.player.getDuration() + 1; // When the video is loaded, ensures that the interval is set to allow the full video to play
        }

        this.startVideo();
    }

    public startVideo() {
        if (this.wvf.RunSlide) {
            setTimeout(() => {
                if (!this.videoState.HasSound)
                    this.player.mute();
                this.player.seekTo(0);
                this.player.playVideo();
            }, 1000);
        }
        else {
            setTimeout(() => {
                this.startVideo();
            }, 1000);
        }
    }
}
